<template>
    <div>
        <h3>テーマの変更</h3>
        <div>
            <p>
                読者は小説を読みやすくするために、テーマを変更することができます。
                テーマの変更は未登録ユーザーでも可能ですが、設定自体に有効期限があります。
                一定期間アクセスがなかった場合は、テーマ設定は既定値に戻ります。
                登録ユーザーの場合は設定が消えることはありません。
            </p>
            <img src="/img/help/read/01.jpg" alt="テーマ設定" class="img-thumbnail mb-3">
            <h4>テーマ設定</h4>
            <p>
                小説本文画面で、目次サイドバーにテーマ変更ボタン（<i class="fas fa-sliders-h"></i>あぁ）
                が表示されます。ここからテーマ設定画面を表示できます。
                あるいは、グローバルサイドバーやナビゲーションバーに表示されるカラーパレットアイコンから、
                色テーマ変更画面を表示できます。
            </p>
            <p>
                テーマ設定では、文字サイズ、背景色、フォント、組み方向を選択できます。
                文字サイズに応じて、最適な行間が設定されます。細かい調整をご自身で行う必要はありません。
            </p>
            <h4>背景色について</h4>
            <p>
                背景色は「フラット背景色」と「グラデーション背景色」の２種類があります。
            </p>
            <p>
                フラット背景色は指定色をベースにしたフラットカラーで、シンプルで可視性の高いデザインを提供します。
                貸し本棚を初めてお使いの方は、フラット背景色を選択することをお勧めします。
            </p>
            <p>
                グラデーション背景色は、指定色を基準にしたグラデーションカラーで、２〜３色が使われます。
                この背景は時間とともに僅かに変化します。
                これらの背景色を選択し、エディタを全画面表示にすることで、執筆の没入感と高品質な体験を提供します。
            </p>
            <h4>縦書きについて</h4>
            <p>
                縦書きにすると、本文を縦書きに表示します。
                ３文字までの連続する半角英数字は縦中横として取り扱います。
            </p>
            <h4>文字出力設定</h4>
            <p>
                文字出力の設定は、「全文」が既定値です。
                これは一般的な小説サイト同様、エピソードの本文をすべて表示します。
                それ以外の「ゆっくり」「通常」「高速」は、ノベルゲームのように本文を１文字ずつ表示します。
                この状態を「<b>文字打ち</b>」と言います。
                この状態のとき「カーソル音」を設定していると、文字の出力時に効果音を鳴らします。
            </p>
            <h5>文字打ちの挙動について</h5>
            <p>
                カーソル音が「無し」のとき、本文を表示すると、最初の段落が自動的に始まります。
                カーソル音を「無し以外」に設定しているときは、本文は表示されません。
                画面上をクリック、タップすることで、次の段落を表示します。
            </p>
            <p>
                「、」や「。」「！」「？」などの文字で表示をウエイトし、改行で入力待ちします。
                入力待ち状態のときは「⏎」というリターン記号が表示されます。
                画面上をクリック、タップすることで、次の段落を表示します。
                スペースキーやエンターキーを押下しても、次の段落を表示します。
                文字打ち中にクリックやタップすると、残りの文字を高速に打ち出します。
            </p>
            <p>
                文字打ち中にエスケープキーかバックスペースキーを押下すると、文字打ちを一時停止することができます。
                ひとつの段落が大きい場合に、途中で一時停止して、ゆっくり読むことができます。
            </p>
            <p>
                文字打ち中は、常にページが最下部（縦書きの場合は最左部）に張り付きます。
                入力待ち中にスクロールできます。
            </p>
            <h5>カーソル音</h5>
            <p>
                カーソル音は以下のとおりです。
                それぞれイメージした音を示していますが、環境によって聴こえ方が変わります。
            </p>
            <ol>
                <li>ｶｶｶｶ...…金庫のダイヤル音。</li>
                <li>ﾄﾞﾙﾙﾙﾙ...…コンクリートブレーカー音。</li>
                <li>ﾄﾄﾄﾄ....…傘を打つ雨音。</li>
            </ol>
            <h5>履歴と次のページ</h5>
            <p>
                文字打ちの場合、自動的にカーソル位置を保存します。
                ページをリロードしたり、離脱しても、続きから読む場合はカーソル位置を復元します。
                同じ小説の他のページを表示すると、カーソル位置はクリアされます。
            </p>
            <p>
                文字打ち中は、次のエピソードへのリンクが表示されません。
                本文すべての文字が表示されると、次のページへのリンクが表示されます。
            </p>
            <p>
                サイドバーの目次から他のエピソードへ遷移する場合、
                現在のエピソードの「先」に遷移すると、カーソル位置が文頭にリセットされます。
                現在のエピソードの「前」に遷移すると、カーソル位置が文末になります。
            </p>
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "小説テーマの変更 | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>